;(function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .controller('ShareUsersController', ShareUsersController)

  /* @ngInject */
  function ShareUsersController ($scope, $rootScope, $q, AdminService, ArtsService, ModalService, ToastService, Utils, CONSTANTS, UserService) {
    const getUseTermsListDialogController = () => $q.when(import('../../dialogs/use-terms/list/use-terms-list-dialog.controller'))

    const userPagination = {
      index: 0,
      top: 20
    }

    $scope.userCount = null
    $scope.users = []

    const api = {
      getUseTermsListDialogController,
      _getUsers,
      _successGetUsers,
      _successGetCollaborators,
      activate
    }
    this.getApi = () => api

    activate()

    function activate () {
      api._getUsers()

      ArtsService.getArtCollaborators($scope.art.id).then(api._successGetCollaborators)
    }

    $scope.removeUser = function (userId) {
      ArtsService.deleteArtCollaborator($scope.art.id, userId).then(() => {
        ArtsService.getArtCollaborators($scope.art.id).then(api._successGetCollaborators)
      })
    }

    $scope.resendEmail = function (userId) {
      ArtsService.resendEmailArtCollaborator($scope.art.id, userId).then(ToastService.defaultSuccessToast).catch(ToastService.defaultErrorToast)
    }

    $scope.handleUserSelect = (event) => {
      $scope.selectedUsers = event.detail
    }

    $scope.onInfiniteUsers = () => {
      userPagination.index++
      api._getUsers()
    }

    $scope.onSearchUsers = (event) => {
      userPagination.index = 0
      api._getUsers(event.detail.search)
    }

    $scope.getAvatarUrl = (user) => {
      return UserService.getUserProfileImage(user.userId)
    }

    function _getUsers (search) {
      const groups = []

      if ($scope.art?.groups) {
        $scope.art.groups.forEach(group => {
          const groupId = groups.find(item => item === group.id)
          if (!groupId) {
            groups.push(group.id)
          }
        })
      }

      const params = {
        status: ['ACTIVE'],
        hideInternalUsers: !$rootScope.isUserSysAdmin(),
        groups,
        search
      }

      AdminService.filterUsers(userPagination.top, userPagination.top * userPagination.index, params).then(api._successGetUsers)
    }

    function _successGetUsers (users) {
      $scope.userCount = users.count
      $scope.users = []

      users.rows.forEach(user => {
        if (user.id !== $rootScope.oUser.id) {
          $scope.users.push({
            label: user.name,
            value: user.id,
            email: user.email,
            id: user.id,
            sendNotification: true,
            url: Utils.fnReplaceStringParams(CONSTANTS.URL_EXTERNAL_USER_PROFILE_IMAGE, [user.id])
          })
        }
      })
    }

    function _successGetCollaborators (data) {
      $scope.invitedUsers = data
    }
  }
})()
